<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Advertisement Details"
      id="admin_view_advert_details"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="warning"
        :to="'/admin/adverts/list/view/' + this.advert_id + '/edit'"
      >
        <v-icon left>mdi-pen</v-icon>
        Edit Ad
      </v-btn>
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="error"
        :to="'/admin/adverts/list/view/' + this.advert_id + '/delete'"
      >
        <v-icon left>mdi-trash-can</v-icon>
        Delete Ad
      </v-btn>
    </CardedSectionHeader>
    <AdvertView :advert="advert"></AdvertView>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Advertisement Statistics (30 days)"
      id="admin_view_advert__stats_details"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        @click="go_to_adverts_report_filtered()"
      >
        View In Report
      </v-btn>
    </CardedSectionHeader>
    <div class="white text-left pa-4">
      The date is in the formart <b>"d/m"</b>, where: <br />
      &nbsp;&nbsp;&nbsp;<b class="ml-6">d</b> is for day of month <br />
      &nbsp;&nbsp;&nbsp;<b class="ml-6">m</b> is for month of the year <br />
      The views on a specific date are shown in brackets <b>()</b> e.g <br />
      &nbsp;&nbsp;&nbsp; <b class="ml-6">13/2 (16)</b> means that on the
      13<small>th</small> of Feb, there were 16 clicks
    </div>
    <SparklineGraph
      :value="grap_value"
      :labels="graph_labels"
      type="trend"
    >
    </SparklineGraph>
  </div>
</template>

<script>
import AdminAdvertsAdd from "./AdminAdvertsAdd";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import PlainDisplay from "../../../components/PlainDisplay";
import SparklineGraph from "../../../components/SparklineGraph";
import AdvertView from "../../../components/AdvertView";


export default {
  name: "AdminAdvertsView",
  components: {
    CardedDisplay,
    CardedSectionHeader,
    PlainDisplay,
    SparklineGraph,
    AdvertView
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      advert: Utils.get_default_advert(),
      advert_id: 0,
      grap_value: [],
      graph_labels: []
    };
  },
  methods: {
    load_advert() {
      this.$emit("on-show-loader");
      ServerClient.Adverts.get_advert_details(
        {
          id: this.advert_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.advert = res;
          //statics
          var today_date_str = Utils.get_today_date_str(new Date());
          var days_30_back = new Date();
          days_30_back = days_30_back.addDays(-30);
          var days_30_back_str = Utils.get_today_date_str(days_30_back);
          var plot_items = Utils.process_advert_clicks_graph_data(
            days_30_back_str,
            today_date_str,
            this.advert.advert_clicks
          );
          this.grap_value = plot_items.values;
          this.graph_labels = plot_items.labels;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading advert details on admin advert view page",
            errors
          );
        }
      );
    },
    on_success_edit_advert() {
      this.load_advert();
    },
    go_to_adverts_report_filtered(){
        this.$router.push("/admin/reports/adverts?id=" + this.advert_id);
    }
  },
  mounted() {
    this.advert_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "View  Ad",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Adverts",
          disabled: false,
          href: "/admin/adverts",
        },
        {
          text: "list",
          disabled: false,
          href: "/admin/adverts/list",
        },
        {
          text: "view",
          disabled: true,
          href: "/admin/adverts/list/view/" + this.advert_id,
        },
      ],
    });
    this.load_advert();
  },
};
</script>